import React, { useEffect, useState } from "react";
import { getServiceUsersInfo } from "../../services/RegistrationService";
import { ServiceUsersContextProvider } from "../../context/ServiceUsersContext";
import ServiceUsersDetailsMobile from "../../components/ServiceUsers/ServiceUsersMobile/ServiceUsersDetailsMobile";
import { getTripDetails } from "../../components/ServiceUsers/ServiceUserData/ServiceUserData";
import { ITripDetails } from "../../components/ServiceUsers/Interfaces/ITripDetails";

interface IParams {
  serviceDetails: string;
  parentPersonId: string;
  personId: string;
}

interface IMatch {
  isExact: boolean;
  params: IParams;
  path: string;
  url: string;
}

interface Props {
  collapsed: boolean;
  match: IMatch;
}

const ServiceDetailsContainer: React.FC<Props> = ({ collapsed, match }) => {
  const [parentPersonId, setParentPersonId] = useState<number>(0);
  const [serviceDetails, setServiceDetails] = React.useState<
    Array<ITripDetails>
  >([]);
  const [personId, setPersonId] = useState<number>(0);
  const [personName, setPersonName] = useState<string>("");
  const [type, setType] = useState<string>("");
  useEffect(() => {
    if (
      match.params.personId &&
      match.params.parentPersonId &&
      match.params.serviceDetails
    ) {
      setPersonId(Number(match.params.personId));
      setParentPersonId(Number(match.params.parentPersonId));
      setType(match.params.serviceDetails);
      handleManageServiceUsersData(Number(match.params.parentPersonId));
      handleTripDetails(Number(match.params.parentPersonId));
    }
  }, [match.params.parentPersonId]);

  async function handleTripDetails(id: number) {
    if (id > 0) {
      const tripDetails: Array<ITripDetails> = await getTripDetails(id);
      setServiceDetails(tripDetails);
    }
  }
  async function handleManageServiceUsersData(personId: number) {
    let data = await getServiceUsersInfo(personId);
    setPersonName(`${data[0].firstName} ${data[0].lastName}`);
  }

  return (
    <ServiceUsersContextProvider>
      <ServiceUsersDetailsMobile
        parentPersonId={parentPersonId}
        personId={personId}
        serviceDetailsList={serviceDetails}
        typeOfService={type}
        serviceUserName={personName}
      />
    </ServiceUsersContextProvider>
  );
};
export default ServiceDetailsContainer;
